module.exports = __webpack_public_path__ + "static/DHCM0-25bccee954472c19c0cdfb3f17bc74d3.png";